import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/toolkit")({
  component: () => (
    <div className="w-full min-w-0 max-w-full overflow-x-clip [box-sizing:border-box]">
      <Outlet />
    </div>
  ),
});
